import { render, staticRenderFns } from "./BrandingUpsell.vue?vue&type=template&id=db31a624"
import script from "./BrandingUpsell.vue?vue&type=script&lang=js"
export * from "./BrandingUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports